<template>
  <div>
    <base-alert
      :type="messageAlert.type"
      dismissible
      v-if="messageAlert.status"
    >
      <span class="alert-inner--icon"><i :class="messageAlert.icon"></i></span>
      <span class="alert-inner--text" v-if="messageAlert.type == 'danger'">
        <ul>
          <li v-for="(arrayMsg, index) in messageAlert.message" :key="index">
            <strong v-for="(msg, i) in arrayMsg" :key="i">{{ msg }}</strong>
          </li>
        </ul>
      </span>
      <span class="alert-inner--text" v-else>
        <strong>{{ messageAlert.message }}</strong>
      </span>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </base-alert>
    <modal
      :show.sync="activarModal"
      body-classes="p-12"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <card
        type="default"
        shadow
        header-classes="bg-white pb-12"
        body-classes="px-lg-12 py-lg-12"
        class="border-0"
      >
        <template>
          <div class="text-muted text-center mb-6">
            <small>{{ cambioForm.titulo }}</small>
          </div>
        </template>
        <template>
          <form role="form">
            <base-input
              alternative
              class="mb-3"
              placeholder="Nombre"
              addon-left-icon="ni ni-email-83"
              v-model="form.nombre"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Apellido"
              addon-left-icon="ni ni-email-83"
              v-model="form.apellido"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Cédula"
              addon-left-icon="ni ni-email-83"
              v-model="form.cedula"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Dirección"
              addon-left-icon="ni ni-email-83"
              v-model="form.direccion"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Teléfono"
              addon-left-icon="ni ni-email-83"
              v-model="form.telefono"
            >
            </base-input>
            <base-input
              alternative
              class="mb-3"
              placeholder="Correo"
              addon-left-icon="ni ni-email-83"
              v-model="form.correo"
            >
            </base-input>
            <base-input
              alternative
              type="password"
              placeholder="Password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="form.password"
            >
            </base-input>
            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                @click="saveEstudiante"
                >{{ cambioForm.nombreBoton }}</base-button
              >
            </div>
          </form>
        </template>
      </card>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal,
  },
  props: ["estudiante", "typeForm", "activarModal", "cambioForm"],
  data: function() {
    return {
      messageAlert: {
        status: false,
        type: null,
        message: {},
        icon: null,
      },
      form: {
        nombre: "",
        cedula: "",
        correo: "",
        direccion: "",
        apellido: "",
        password: "",
        telefono: "",
      },
      formDefault: {
        nombre: "",
        cedula: "",
        correo: "",
        direccion: "",
        apellido: "",
        password: "",
        telefono: "",
      },
      nombreBoton: "",
      titulo: "",
    };
  },
  computed: {
    cambioForm() {
      let estudiante = this.estudiante;
      if (this.typeForm != "Crear") {
        this.form = this.estudiante;
        return { nombreBoton: "Actualizar", titulo: "Actualizar" };
      } else {
        this.form = this.formDefault;
        return { nombreBoton: "Registrar", titulo: "Registrar" };
      }
    },
  },
  watch: {
    /* typeForm: function(val){
           const formDefault = {nombre:'',cedula:'',correo:'',direccion:'',apellido:'',password:'',telefono:''};
            if (val === 'Crear') {
                this.form = formDefault;
                //this.nombreBoton = 'Registrar';
                this.titulo = 'Registrar nuevo estudiante';
            }else{
                this.form = this.estudiante;
                this.nombreBoton = 'Actualizar';
                this.titulo = 'Editar estudiante';
            }
        },
        activarModal:function(val){
            if (val === false) {
                this.form = this.formDefault;                                
            }
        }*/
  },
  methods: {
    async saveEstudiante() {
      //const typeForm = this.typeForm;
      const data = this.form;
      if (this.typeForm === "Crear") {
        var url = "students";
        var method = "post";
        var message = "Se creo el estudiante correctamente";
      } else {
        var url = "students/" + this.estudiante.id;
        var method = "put";
        var message = "Se edito el estudiante correctamente";
      }
      try {
        await this.$api({
          url: url,
          method: method,
          data: data,
        });
        this.messageConfig("success", "ni ni-like-2", message);
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          if (e.response.status == "422") {
            console.log(e.response.data);
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              e.response.data.errors
            );
          } else {
            this.messageConfig(
              "danger",
              "ni ni-fat-remove",
              "Ocurrio un error, por favor contacte con el administrador de sistema."
            );
          }
        }
      }
      this.initForm();
      this.$emit("listarEstudiantes");
    },
    initForm() {
      this.form = {
        nombre: "",
        cedula: "",
        correo: "",
        direccion: "",
        apellido: "",
        password: "",
        telefono: "",
      };
    },
    messageConfig(type, icon, message) {
      this.messageAlert.status = true;
      this.messageAlert.type = type;
      this.messageAlert.message = message;
      this.messageAlert.icon = icon;
      setTimeout(() => {
        this.messageAlert.status = false;
      }, 5000);
    },
  },
};
</script>
